module.exports = __webpack_public_path__ + "static/media/Artboard14s.c325874f.gif";